import { render } from "./CompanyKnowledgeBase.vue?vue&type=template&id=5f831e73&scoped=true"
import script from "./CompanyKnowledgeBase.vue?vue&type=script&lang=js"
export * from "./CompanyKnowledgeBase.vue?vue&type=script&lang=js"

import "./CompanyKnowledgeBase.vue?vue&type=style&index=0&id=5f831e73&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f831e73"]])

export default __exports__